import { useEffect, useState } from 'react';
import { createPwaInstallController, type PwaInstallControls } from '@/lib/pwa-install';

export type { PwaInstallControls } from '@/lib/pwa-install';

/** Mount above auth gates so browser install events survive session restoration. */
export function usePwaInstall(): PwaInstallControls {
  const [controller] = useState(() => createPwaInstallController(window));
  const [state, setState] = useState(controller.getState);

  useEffect(() => controller.subscribe(setState), [controller]);

  return { ...state, install: controller.install, dismiss: controller.dismiss };
}
